(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-main"]) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
const cartItems = document.querySelectorAll('[data-aid="cart-item"]');
  cartItems.forEach(item => {
    const minQty = parseInt(item.dataset.minQuantity);
    const maxQty = parseInt(item.dataset.maxQuantity);
    const quantityInput = item.querySelector('.input-quantity');
    const minQtySpan = item.querySelector('.min-quantity-message');
    const maxQtySpan = item.querySelector('.max-quantity-message');

    let quantity = parseInt(quantityInput.value);

    if (quantity == minQty) {
      if (minQtySpan) {
        minQtySpan.classList.remove('visually-hidden');
        maxQtySpan.classList.add('visually-hidden');
      }

    } else if (quantity == maxQty) {
      if (maxQtySpan) {
        maxQtySpan.classList.remove('visually-hidden');
        minQtySpan.classList.add('visually-hidden');
      }
    }
  });
});


  } catch(e) { console.error(e); }
})();
})();
